module.exports = __webpack_public_path__ + "static/kartik-2e35a5ab7ed70ec0ddf8ec24dc9fc07b.png";